import React from 'react';
import { ReactSVG } from 'react-svg';
import GreetIcon from '../assets/icons/undraw_Hello_qnas.svg';

import '../styles/main.css';

const Main = () => {
    return (
        <div className="main">
            <div className="text">
                <h1>Hello, I'm Hud</h1>

                <p>
                    Been coding almost 1 year 
                    with React Lorem ipsum dolor sit amet consectetur, 
                    adipisicing elit. Accusamus ea pariatur harum delectus quo, 
                    neque modi debitis! Deleniti, enim at! Reiciendis ut labore 
                    ratione voluptatibus sint? Nostrum sit autem voluptatum.
                </p>
            </div>

            <ReactSVG
                src={GreetIcon}
                beforeInjection={(svg) => {
                    svg.style.width = '200px';
                    svg.style.height = '200px';
                }}
                wrapper="div"
            />
        </div>
    )
}

export default Main
